import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {TruncateDirective} from '@aviary/directives/truncate.directive';

@Component({
  selector: 'px-combined-availability-branch-name',
  host: {
    class: 'flex flex-row gap-x-2 items-center'
  },
  template: `
    @if (available) {
      <mat-icon class="text-success mat-icon-size-6 mr-2 shrink-0">check_circle</mat-icon>
    } @else {
      <mat-icon class="text-error mat-icon-size-6 mr-2 shrink-0">cancel</mat-icon>
    }
    <span mxTruncate>{{ name }}</span>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, TruncateDirective]
})
export class CombinedAvailabilityBranchNameComponent {
  @Input({required: true}) available: boolean;
  @Input({required: true}) name: string;
}
